import { Block, type ErrorComponentProps, Outlet } from '@tanstack/react-router';
import { DefaultErrorFallback, ErrorFallbackActions } from '@/components/Error';
import { BlockedLogout } from '@/components/Logout/BlockedLogout';
import { isSessionAuthError } from '@/helpers/auth';
import { ButtonLink } from '@/router/Link';

export const AuthenticatedComponent = () => (
  <Block
    withResolver={true}
    shouldBlockFn={({ next: { routeId, search } }) => routeId === '/(auth)/logout' && isSessionAuthError(search.aerr)}
    enableBeforeUnload={false}
  >
    {({ status, next }) =>
      status === 'blocked' &&
      /* next, aid TS inference of 'search': */
      next.routeId === '/(auth)/logout' &&
      isSessionAuthError(next.search.aerr) ? (
        <BlockedLogout reason={next.search.aerr} />
      ) : (
        <Outlet />
      )
    }
  </Block>
);

export const AuthenticatedErrorFallback = (props: ErrorComponentProps) => (
  <DefaultErrorFallback
    {...props}
    ActionsComponent={(actions) => (
      <>
        {actions.back}
        <ErrorFallbackActions>
          <ButtonLink to="/logout" variant="outlined" size="small">
            Logout
          </ButtonLink>
          {actions.retry}
        </ErrorFallbackActions>
      </>
    )}
  />
);
